import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

/**
 * Prompts a user before they exit the page
 */
function useUnsavedChangesPrompt(enabled = true) {
  const blocker = useBlocker(enabled);

  const message = 'Are you sure? Changes that you made may not be saved.';

  // UseBlocker to prompt before navigating in the SPA
  // https://stackoverflow.com/a/75840128
  useEffect(() => {
    if (blocker.state !== 'blocked') return;

    /**
     * The form saved between the navigation being blocked and this effect
     * running — a save that resets the form and then navigates does exactly
     * that, because the reset only reaches this hook on the next render. There
     * is nothing left to lose, so let the navigation through: resetting it here
     * cancels the save's own redirect and the user has to click again
     * (APP-2237, QA note 5).
     */
    if (!enabled) {
      blocker.proceed?.();

      return;
    }

    if (window.confirm(message)) {
      blocker.proceed?.();
    } else {
      blocker.reset?.();
    }
  }, [blocker, enabled]);

  // Prompt before page refresh or if navigating away from the SPA
  useEffect(() => {
    if (enabled) {
      window.onbeforeunload = () => message;
    }

    return () => {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      window.onbeforeunload = () => {};
    };
  }, [message, enabled]);
}

export default useUnsavedChangesPrompt;
